<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>

    <div v-if="!isLoading" class="section">
      <div class="columns is-multiline">
        <div class="column is-offset-1 is-10">
          <div class="columns is-vcentered content">
            <div class="column is-10">
              <h1 class="title is-2">{{ training.fields.title }}</h1>
            </div>
            <div class="column is-2">
              <router-link :to="{ name: 'trainings' }" class="button is-info is-pulled-right">
                <font-awesome-icon icon="arrow-up"></font-awesome-icon>
                &nbsp; Vissza
              </router-link>
            </div>
          </div>
          <TrainingDetailsCard :training="training"></TrainingDetailsCard>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* Services */
  import Contentful from '@/services/Contentful'

  /* Components */
  import TrainingDetailsCard from '@/components/General/TrainingDetailsCard'
  import Loader from '@/components/General/Loader'

  export default {
    data () {
      return {
        training: {},
        isLoading: true
      }
    },
    async mounted () {
      /* Get Id */
      const trainingId = this.$store.state.route.params.trainingId
      /* Get best practice */
      this.training = (await Contentful.getSingleEntriesByContentTypeAndId('training', trainingId)).data
      this.isLoading = false
      /* Scroll to top */
      window.scrollTo(0, 0)
    },
    components: {
      TrainingDetailsCard,
      Loader
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ViewTraining.vue